export function ErrorState() {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            عذراً، حدث خطأ
          </h1>
          <p className="text-gray-600">لم نتمكن من تحميل تفاصيل الخبر</p>
        </div>
      </div>
    </div>
  );
}
